import '@fontsource/be-vietnam';
import 'bz-core-controls/utils/reflect-metadata';
import './App.css';
import './main.styl';
import './responsive.styl';

import 'bz-utilities/global';

import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';

import { observer } from 'mobx-react-lite';

import MobileDetect from 'mobile-detect';

import LoadingPanel from 'bz-core-controls/controls/layout/loading-panel';
import Fallback from 'bz-core-controls/controls/lazy/controls/fallback';
import BzTheme from 'bz-core-controls/styles/theme';

import AuthStore from 'bz-stores/lib/auth-store';

import history from 'bz-utilities/modules/networking/history/rr4';
import VersionCheck from 'bz-utilities/modules/version-check';

import { LoginRoutePaths } from 'core/auth';
import { RouteTracking } from 'core/analytics/june/context';

import ClickAppProviders from './providers';

const AuthPages = React.lazy(() => import('./components/auth'));
const Signup = React.lazy(() => import('./components/auth/signup'));
const ProntoSignup = React.lazy(() => import('./components/auth/signup/controls/pronto'));

const InvoicePrint = React.lazy(
  () =>
    import(
      './components/contacts/contact-details/tabs/pronto-referrals/referral/controls/print/invoice'
    )
);
const ReferralSignUpExisting = React.lazy(() => import('./components/referral-signup-existing'));
const ReferralSignUpExistingComplete = React.lazy(
  () => import('./components/referral-signup-existing/complete')
);
const AuthenticatedApp = React.lazy(() => import('./shell/app'));

window.React = React;
window.mobileDetection = new MobileDetect(window.navigator.userAgent);

const AuthLoader = observer(() => {
  try {
    if (AuthStore.authenticated) return <AuthenticatedApp />;
    AuthStore.checkLoginState();

    return (
      <div className="h-full w-full">
        <LoadingPanel />
      </div>
    );
  } catch {
    return (
      <div className="h-full w-full">
        <LoadingPanel />
      </div>
    );
  }
});

function App() {
  return (
    <>
      <VersionCheck />
      <div className="click-app">
        <BzTheme theme={{ primary: 'clickBlue' }} />
        <ClickAppProviders>
          <React.Suspense fallback={<Fallback />}>
            <Router history={history.browserHistory}>
              <RouteTracking />
              <Switch>
                <Route path={LoginRoutePaths} component={AuthPages} />
                <Route path="/pronto-signup/:token" component={ProntoSignup} />
                <Route path="/signup/:token?" exact={true} component={Signup} />
                <Route
                  path="/pronto-referrals/referral/:referralId/print/invoice/:invoiceId"
                  component={InvoicePrint}
                />
                <Route path="/referral-signup/:token?" component={Signup} />
                <Route
                  path="/referral-signup-existing/complete"
                  component={ReferralSignUpExistingComplete}
                />
                <Route path="/referral-signup-existing" component={ReferralSignUpExisting} />
                <Route component={AuthLoader} />
              </Switch>
            </Router>
          </React.Suspense>
        </ClickAppProviders>
      </div>
    </>
  );
}

export default App;
